import React, { memo } from 'react';
export const MemorabiliaBanner = () => {
  return <section id="memorabilia" className="relative w-full min-h-[400px] md:min-h-[500px] flex items-center justify-center overflow-hidden bg-ink" data-id="element-111">
      {/* Parallax Background */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat bg-fixed" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1566577739112-5180d4bf9390?q=80&w=2800&auto=format&fit=crop")'
    }} data-id="element-112" />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-ink/80" data-id="element-113" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center py-16" data-id="element-114">
        <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white mb-6 uppercase tracking-wide max-w-4xl leading-tight drop-shadow-[4px_4px_0px_rgba(0,0,0,1)]" data-id="element-115">
          Own a Piece of <span className="text-scarlet" data-id="element-116">History</span>
        </h2>
        <p className="text-xl md:text-2xl font-bold text-white mb-10 max-w-2xl drop-shadow-[2px_2px_0px_rgba(0,0,0,1)]" data-id="element-117">
          Explore our premium collection of game-used gear, signed full-size
          helmets, and exclusive Ohio State memorabilia.
        </p>
        <a href="#memorabilia" className="bg-scarlet text-white font-heading text-xl tracking-wider px-10 py-4 border-4 border-ink shadow-comic hover:shadow-comic-hover hover:translate-x-[4px] hover:translate-y-[4px] transition-all text-center min-h-[56px] flex items-center justify-center w-full sm:w-auto" data-id="element-118">
          View Memorabilia
        </a>
      </div>
    </section>;
};